import React, { useEffect } from "react";
import { Link } from "react-router-dom";
// import AdBanner from "../components/AdBanners"; // Component to render ad banners


const Advertise = () => {
  
  /**
   * Effect to update date & time widgets every second
   * Uses setInterval to refresh content and updates DOM elements directly
   */
  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      const dateOptions = { weekday: "short", day: "numeric", month: "short", year: "numeric" };
      const timeOptions = { hour: "2-digit", minute: "2-digit", second: "2-digit" };

      const dateEl = document.getElementById("widget-date"); // Target div for date
      const timeEl = document.getElementById("widget-time"); // Target div for time

      if (dateEl && timeEl) {
        dateEl.textContent = now.toLocaleDateString("en-US", dateOptions); // Format: Mon, 29 Sep 2025
        timeEl.textContent = now.toLocaleTimeString("en-US", timeOptions); // Format: 10:30:15 PM
      }
    }, 1000);

    // Cleanup: remove interval on component unmount
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="container mx-auto px-4 mt-6 lg:flex gap-6">
      {/* Main Content Section */}
      <div className="lg:w-8/12 w-full mb-10">
        <div className="bg-white p-6 rounded shadow-sm">
          <h1 className="text-2xl font-bold mb-4">Advertise With Us</h1>

          {/* Intro Paragraph */}
          <p className="mb-4">
            Welcome to <strong>Newstarn</strong>, your go-to platform for the latest and most relevant news.
            Our rapidly growing audience stays updated on politics, business, technology, sports, and health,
            making it the perfect place to showcase your brand.
          </p>

          {/* Advertising options overview */}
          <p className="mb-4">
            We offer a variety of advertising options, including banner ads, sponsored content, and native ads
            that seamlessly blend into the reading experience. Get your brand in front of an engaged and
            informed audience today.
          </p>

          {/* Banner sizes, formats, and contact CTA */}
          <p className="mb-4">
            You can advertise with us using banners of aspect ratios:{" "}
            <strong>800×450, 728×90, 160×600, 300×600</strong>,{" "}
            <strong>video</strong>, <strong>textual/script</strong> formats or any other multimedia element
            specified by you. 📩 <strong>Interested in advertising with us?</strong>{" "}
            <Link to="/contactus" className="text-blue-600 font-bold hover:underline">
              Contact Our Team
            </Link>{" "}
            for pricing and placement options.
          </p>
        </div>
      </div>

      {/* Sidebar Section */}
      <aside className="lg:w-4/12 w-full mt-6 lg:mt-0">
        {/* Date & Time Widget */}
        <div className="aside-widget p-4 mb-6 bg-white rounded shadow-sm">
          <div className="widget-header font-bold">Current Time</div>
          <div id="widget-date" className="date text-sm mt-1"></div> {/* Populated by useEffect */}
          <div id="widget-time" className="time text-lg mt-1"></div>  {/* Populated by useEffect */}
        </div>

        {/* Ad Banner component */}
        {/* Props: keyId = ad unit key, width & height in px, delay before showing in ms */}
        {/* <AdBanner keyId="e34bc345ee5e3a91f6b935de958d5097" width={300} height={250} delay={3000} /> */}

        {/* Optional Trending Posts Section */}
        {/* 
        <div className="bg-gray-100 p-4 mb-6 rounded">
          <h3 className="text-md font-semibold mb-3">Trending</h3>
          <ul className="list-disc pl-4 text-sm space-y-2">
            {news.slice(0, 3).map((item, index) => (
              <li key={index}>{item.title}</li>
            ))}
          </ul>
        </div> 
        */}
      </aside>
    </div>
  );
};

export default Advertise;
